import { initShopifyHlsAutoplayVideos } from '../lib/video-shopify-hls.js';

document.addEventListener('DOMContentLoaded', () => {
  initShopifyHlsAutoplayVideos();

  const containers = document.querySelectorAll('.js-video-autoplay');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const container = entry.target;

        if (container.classList.contains('js-shopify-hls')) {
          return;
        }

        const video = container.querySelector(':scope > video');
        const iframe = container.querySelector(':scope > iframe');

        if (entry.isIntersecting) {
          if (video) {
            video.muted = true;
            video.setAttribute('playsinline', '');
            const p = video.play();
            if (p !== undefined) {
              p.catch(() => {});
            }
            if (video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
              video.addEventListener('loadeddata', () => {
                video.muted = true;
                video.play().catch(() => {});
              }, { once: true });
            }
            video.addEventListener('canplay', () => {
              video.muted = true;
              video.play().catch(() => {});
            }, { once: true });
          } else if (iframe) {
            const src = iframe.src;

            if (src.includes('youtube.com')) {
              iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            } else if (src.includes('vimeo.com')) {
              iframe.contentWindow.postMessage('{"method":"play"}', '*');
            }
          }
        } else if (video) {
          video.pause();
          container.querySelector('.video-section__poster')?.classList.remove('is-playing');
        } else if (iframe) {
          const src = iframe.src;

          if (src.includes('youtube.com')) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (src.includes('vimeo.com')) {
            iframe.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      });
    },
    {
      threshold: 0.01
    }
  );

  containers.forEach((container) => {
    observer.observe(container);

    const video = container.querySelector(':scope > video');
    const poster = container.querySelector('.video-section__poster');

    if (video && poster) {
      video.addEventListener('playing', () => {
        poster.classList.add('is-playing');
      });
    }

    if (video) {
      video.addEventListener('click', () => {
        video.controls = true;
        video.muted = false;
        video.play().catch(() => {});
      });
    }
  });
});
